import { borderColor } from '@Styles/colors';
import { css, StyleSheet } from 'aphrodite';
import * as ResizablePrimitive from 'react-resizable-panels';

function ResizablePanelGroup({ styles = [], ...props }: AphroditeStyled<ResizablePrimitive.GroupProps>) {
	return (
		<ResizablePrimitive.Group
			data-slot='resizable-panel-group'
			className={css(s.resizablePanelGroup, ...styles)}
			{...props}
		/>
	);
}

function ResizablePanel({ ...props }: ResizablePrimitive.PanelProps) {
	return <ResizablePrimitive.Panel data-slot='resizable-panel' {...props} />;
}

function ResizableHandle({
	withHandle,
	styles = [],
	...props
}: AphroditeStyled<
	ResizablePrimitive.SeparatorProps & {
		withHandle?: boolean;
	}
>) {
	return (
		<ResizablePrimitive.Separator data-slot='resizable-handle' className={css(s.resizableHandle, ...styles)} {...props}>
			{withHandle && <div className={css(s.resizableHandleThumb)} />}
		</ResizablePrimitive.Separator>
	);
}

export { ResizableHandle, ResizablePanel, ResizablePanelGroup };

const s = StyleSheet.create({
	resizablePanelGroup: {
		boxSizing: 'border-box',
		display: 'flex',
		width: '100%',
		height: '100%',
		':is([aria-orientation=vertical])': {
			flexDirection: 'column',
		},
	},
	resizableHandle: {
		position: 'relative',
		boxSizing: 'border-box',
		display: 'flex',
		width: 1,
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: borderColor,
		':is([aria-orientation=horizontal])': {
			height: 1,
			width: '100%',
		},
		':is([aria-orientation=horizontal]):after': {
			left: 0,
			height: 1,
			width: '100%',
			transform: 'translate(0, -50%)',
		},
		':is([aria-orientation=horizontal])>div': {
			transform: 'rotate(90deg)',
		},
		':after': {
			position: 'absolute',
			top: 0,
			bottom: 0,
			left: '50%',
			width: 4,
			transform: 'translateX(-50%)',
			content: '""',
		},
		':focus-visible': {
			outlineStyle: 'none',
			boxShadow:
				'rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, lab(66.128 -0.0000298023 0.0000119209) 0px 0px 0px 1px, rgba(0, 0, 0, 0) 0px 0px 0px 0px',
		},
	},
	resizableHandleThumb: {
		zIndex: 10,
		display: 'flex',
		boxSizing: 'border-box',
		height: 24,
		width: 4,
		flexShrink: 0,
		borderRadius: 8,
		backgroundColor: borderColor,
	},
});
